exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1psm6{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._1psm6 ._1eDNa{color:#555;color:-wix-colors-buttonsAndLinksColor}[data-layout=\"2\"] ._1psm6 ._1eDNa{color:-wix-colors-mobileButtonsBackgroundColor}", ""]);

// exports
exports.locals = {
	"spinner-container": "_1psm6",
	"spinnerContainer": "_1psm6",
	"spinner": "_1eDNa"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/components/mobile-spinner-overlay/mobile-spinner-overlay.styl
// module id = 2147
// module chunks = mobile-overlay/mobile-overlay mobile/mobile